export const GET_REPORT = 'get-report';
